document.addEventListener('DOMContentLoaded', function () {
  const videosContainer = document.querySelector('.testimonials--videos');

  if (videosContainer) {
    const videos = videosContainer.querySelectorAll('video-element');

    videos.forEach(video => {
      video.addEventListener('video:play', function () {
        videos.forEach(otherVideo => {
          if (otherVideo !== video && otherVideo.playing) {
            otherVideo.pause();
          }
        });
      });
    });
  }
});
